import React from 'react';
import { Box, Typography } from '@mui/material';

const SectionHeader = ({ title, subtitle, action, id }) => (
  <Box sx={{ display: 'flex', alignItems: { xs: 'flex-start', sm: 'flex-end' }, justifyContent: 'space-between', gap: 2, mb: 2, flexWrap: 'wrap' }}>
    <Box>
      <Typography variant="h2" component="h2" id={id}>{title}</Typography>
      {subtitle && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{subtitle}</Typography>}
    </Box>
    {action}
  </Box>
);

export default SectionHeader;
